// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__2MrNa","dense":"Label_dense__7o3UE"};